import {
  logEvent,
  setUserId,
  setUserProperties,
  type Analytics,
} from 'firebase/analytics';

let analyticsInstance: Analytics | null = null;

export function initAnalytics(analytics: Analytics | null) {
  analyticsInstance = analytics;
}

function track(eventName: string, params?: Record<string, unknown>) {
  if (!analyticsInstance) return;
  if (import.meta.env.DEV) {
    console.log('[Analytics]', eventName, params);
  }
  logEvent(analyticsInstance, eventName, params);
}

export const analytics = {
  // Page views with location context
  pageView: (
    pagePath: string,
    pageTitle: string,
    locationLabel?: string | null,
    locationSource?: string
  ) =>
    track('page_view', {
      page_path: pagePath,
      page_title: pageTitle,
      location_label: locationLabel || 'unknown',
      location_source: locationSource || 'gps',
    }),

  // Auth events
  login: (method: 'google' | 'email') => track('login', { method }),
  logout: () => track('logout'),

  // Bar engagement
  viewBar: (barId: string, barName: string) =>
    track('view_item', { item_id: barId, item_name: barName }),
  addFavorite: (barId: string, barName?: string) =>
    track('add_to_wishlist', { item_id: barId, item_name: barName }),
  removeFavorite: (barId: string, barName?: string) =>
    track('remove_from_wishlist', { item_id: barId, item_name: barName }),

  // Location tracking
  selectCity: (cityName: string, citySlug: string) => {
    track('select_content', {
      content_type: 'city',
      item_id: citySlug,
      item_name: cityName,
    });
  },
  useGps: () => track('use_gps'),

  // User identification + city property
  setUser: (userId: string | null, props?: Record<string, string>) => {
    if (!analyticsInstance) return;
    setUserId(analyticsInstance, userId);
    if (props) {
      setUserProperties(analyticsInstance, props);
    }
  },

  setUserCity: (cityName: string | null) => {
    if (!analyticsInstance) return;
    setUserProperties(analyticsInstance, { user_city: cityName || 'gps' });
  },

  // App install banner
  appBannerShown: () => track('app_banner_shown'),
  appBannerClicked: () => track('app_banner_clicked'),
  appBannerDismissed: () => track('app_banner_dismissed'),
};
